var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('review-order',{ref:"order",attrs:{"type":_vm.type},on:{"clearDetails":_vm.clearDetails,"showDetails":_vm.showDetails}}),_c('review-detail',{ref:"details"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }